import { indexOf } from "lodash"
// const url = window.location.toString().split('/')
// const url_local = url[indexOf(url,'localhost')
const url_local = window.location.toString().split('/fflip')[0] + '/fflip'
export const BASE_URL_APP = process.env.NODE_ENV === 'production'
? window.BASE_URL_VUE
: `${url_local}/`
